import Vue from 'vue'
import Router from 'vue-router'
import store from 'store'
import routes from './syncRouter.js'
import { getRole_route } from 'service/utils'
import VueCookies from "vue-cookies"

import { Message } from 'element-ui';

Vue.use(Router)
const router =  new Router({
    mode: 'history',
    routes: routes
})
/**默认路由集合
 * 不验证权限
 * 每个角色都有的
 * */ 
const commonRoutes = [
    '/workbench/console',
    '/personage/info',
    '/personage/index',
    '/updatePassword',
]
let checkToken = function() {
    let token = VueCookies.get('token')
    return {
        status: token ? 1 : 0
    }
}
let checkPermission = function(path){
    let routeArr = Object.keys(getRole_route())
    if(!path) return false
    return commonRoutes.includes(path) || routeArr.includes(path)
}

router.beforeEach((to, from, next) => {
    if (to.meta.auth) {
        var check = async function() {
            const result_login = await checkToken()
            const result_route = await checkPermission(to.path)
            if (result_login.status == 1) {
                if(result_route){
                    store.commit('global/CLEARHTTP')
                    next();
                }else {
                    Message({
                        message: '当前角色没有此菜单权限，请联系管理员',
                        type: 'warning'
                    })
                    next(false)
                }
            } else {
                next({ path: '/login' })
            }
        }
        check()
    } else {
        store.commit('global/CLEARHTTP')
        next();
        /* if(from.name===null){
            //store.commit('auth/EXIT')
            store.dispatch('auth/EXIT')
        }
        var check = async function() {
            const result_login = await checkToken()
            if(result_login.status == 1){
                next({ path: '/' });
            }else{
                //store.commit('global/CLEARHTTP')
                store.dispatch('global/CLEARHTTP')
                next();
            }
        }
        check() */
    }
})

router.afterEach(route => {
    //loading加载完成
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js